import React, { useState, useEffect } from "react";
import { Frame, ScalingContainer, Header } from "../../../AppStyled";
import BallsGrid from "./BallsGrid";
import { InfoPair, InfoTrio, Button, Names, Loader } from "./SecondPage";

import useSound from "use-sound";
import goForward from "../../../audio/goForward.mp3";

export default function BetReplay({
  unBlur,
  scrollable,
  h,
  handleAbove,
  userSettings,
  betReplay,
  handleBetReply,
  handleNotification,
  userSettings: { sound, volume },
  toFix
}) {
  const [goForwardSfx] = useSound(goForward, { volume });

  const {
    bet_id,
    betAmount,
    winAmount,
    currency,
    winCoef,
    client_seed,
    server_seed,
    server_seed_SHA256,
    nonce,
    dealer,
    player,
    dealerWinPositions,
    playerWinPositions,
  } = betReplay;

  useEffect(() => {
    return () => {
      handleBetReply({});
    };
  }, [handleBetReply]);
  const [animSG, setanimSG] = useState(false);
  const [clicked, setclicked] = useState(false);
  return (
    <Frame
      className="BetReplayFrame"
      data-test="betreplay"
      opacity="true"
      unBlur={unBlur}
      scrollable={scrollable}
    >
      <ScalingContainer
        className="ScalingContainer"
        h={h}
        style={{ overflow: "scroll", scrollbarWidth: "none" }}
      >
        <Header
          name="BET REPLY"
          userSettings={userSettings}
          handleAbove={handleAbove}
        />
        {bet_id ? (
          <>
            <InfoPair title="Bet ID" text={bet_id} />
            <Names>Dealer</Names>
            <BallsGrid
              dealer={dealer}
              player={player}
              winPositionsDealer={dealerWinPositions}
              winPositionsPlayer={playerWinPositions}
            />
            <Names>Player</Names>
            <InfoTrio
              betAmount={betAmount}
              winCoef={winCoef}
              winAmount={winAmount}
              currency={currency}
              toFix={toFix}
            />
            <InfoPair
              title="Client seed"
              text={client_seed}
              handleNotification={handleNotification}
              cursorPointer
            />
            <InfoPair
              title={!!server_seed ? "Server seed" : "Server seed hash"}
              text={!!server_seed ? server_seed : server_seed_SHA256}
              handleNotification={handleNotification}
              cursorPointer
            />
            <InfoPair
              title="Nonce"
              text={nonce}
              handleNotification={handleNotification}
              cursorPointer
            />
            <div style={{ height: 57, marginBottom: 30 }}>
              <Button
                data-test="verifyTest"
                onClick={() => {
                  if (!clicked) {
                    setclicked(true);
                    if (sound) goForwardSfx();

                    setanimSG(true);
                    setTimeout(() => {
                      setclicked(false);

                      // handleAbove("guide");
                      handleAbove("history");
                    }, 500);
                  }
                }}
                animSG={animSG}
              >
                <div className="yellow" />
                <div className="white" />
                {/* VERIFY BET */}
                OK
              </Button>
            </div>
          </>
        ) : (
          <Loader>
            <p className="loading">
              Loading
              <span />
              <span />
              <span />
            </p>
          </Loader>
        )}
      </ScalingContainer>
    </Frame>
  );
}

//   const [setA, setSetA] = useState(false);

//   const setAnimation = (a, b) => {
//     if (a) {
//       b(false);
//       clearTimeout();
//     } else {
//       b(true);
//       setTimeout(() => {
//         b(false);
//       }, 500);
//     }
//   };

// betAmount: 2000
// bet_id: 55804
// bigWin: 0
// client_seed: "e8376fe29ba1b52cc10ef3c7b836b4be7394e46d329282716b5d1da11f9e0eee"
// currency: "USD"
// date: "2020-11-03 19:55:50"
// dealer: (5) ["5", "5", "3", "6", "3"]
// dealerWinPositions: (5) ["1", "1", "1", "0", "1"]
// dealerWinType: "2"
// nonce: 30
// player: (5) ["3", "5", "3", "5", "6"]
// playerWinPositions: (5) ["1", "1", "1", "1", "0"]
// playerWinType: "2"
// round_id: "33bd6791-e90f-457a-bb42-97389ad6336e"
// server_seed: ""
// server_seed_SHA256: "7916246ba480f29b9a9795a7e02d85a091f06921fdacf9d35367c450213043f6"
// type: "117"
// user_id: "178"
// user_name: "Name_178"
// winAmount: 2000
// winCoef: 1
